import { useCallback, useEffect, useState } from "react";

/**
 * Hook personalizado para requisições com fetch.
 * @param {string} initialUrl - URL inicial da requisição.
 * @param {object} initialOptions - Configurações padrão para fetch.
 * @returns {object} - Estados e funções: { data, loading, error, refetch }.
 */
const useFetch = (initialUrl, initialOptions = {}) => {
  const [url, setUrl] = useState(initialUrl);
  const [options, setOptions] = useState(initialOptions);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await fetch(url, options);

      if (!response.ok) {
        throw new Error(`Erro: ${response.status} - ${response.statusText}`);
      }

      const result = await response.json();
      setData(result);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [url, options]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const refetch = (newUrl = initialUrl, newOptions = initialOptions) => {
    setUrl(newUrl);
    setOptions(newOptions);
  };

  return { data, loading, error, refetch };
};

export default useFetch;
